import React from 'react';
export const Myfamily = ({currentpage,setcurrentpage}) => {
  if (currentpage==="/My_family") {
	  return (
		<div>
			<h1>My Family</h1>
		</div>
	  );
  }
};